import { IParams, IUser } from "../types/interfaces";
import api from "./api";

/**
 * getMe extracts contextual user definitions evaluating explicit database parameters.
 */
export const getMe = async (): Promise<IUser & { permissions: string[] }> => {
  const response = await api.get("/auth/me");
  return response.data;
};

export const getUsers = async (params: IParams) => {
  const response = await api.get("/users", { params });
  return response.data;
};

export const createUser = async (data: Partial<IUser>) => {
  const response = await api.post("/users/admin-create", data);
  return response.data;
};

export const updateUser = async (data: Partial<IUser>) => {
  const response = await api.put(`/users`, data);
  return response.data;
};

export const deleteUser = async (id: number) => {
  const response = await api.delete(`/users/${id}`);
  return response.data;
};

export const disableUser = async (id: number) => {
  const response = await api.put(`/users/${id}/disable`);
  return response.data;
};

export const enableUser = async (id: number) => {
  const response = await api.put(`/users/${id}/enable`);
  return response.data;
};

export const updatePermissions = async (id: number, permissions: string[]) => {
  const response = await api.post("/roles/user/permission", {
    id,
    permissions,
  });
  return response.data;
};

/**
 * exportUsersCSV triggers bulk extraction of filters into Blob data dynamically.
 */
export const exportUsersCSV = async (params?: Partial<IParams>): Promise<Blob> => {
  const response = await api.get("/users/export", {
    params: params || {},
    responseType: "blob",
  });
  return response.data;
};

export const importUsersCSV = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await api.post("/users/import", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};
